import { Card } from "antd";

import "./style.css";
const AboutUs = () => {
  return (
    <div className="aboutus-container">
      <Card className="aboutus-card">
        <h3>درباره ما</h3>
        <div className="aboutus-paragraph">
          <p>
            وبسلا به عنوان پلتفرم خدمات آنلاین مراکز درمانی فعالیت دارد. ما به
            دنبال راه هایی برای تسهیل دسترسی شما به خدمات پزشکی هستیم و به بهبود
            وضعیت سلامت شما متعهدیم.
          </p>
          <p>
            خدمات الکترونیکی که در وب سایت وبسلا ارایه می شود عبارتند از نوبت
            دهی مراکز درمانی و صدور نسخ الکترونیک
          </p>
        </div>
      </Card>
    </div>
  );
};

export default AboutUs;
